import { AsyncPipe, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { notificationAnimation } from '@app/shared/ui/notification/notification.animations';
import { NotificationService } from '@core/services/notification.service';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-notification',
  template: `@if (notification$ | async; as notification) {
    <div class="notification__wrapper" @notificationAnimation aria-hidden="true">
      <div class="notification">
        @if (!notification?.isError) {
          <img class="notification__icon" ngSrc="/assets/icons/success-icon.svg" alt="success" height="32" width="32" />
        } @else {
          <img class="notification__icon" ngSrc="/assets/icons/error-icon.svg" alt="error" height="32" width="32" />
        }
        <div class="notification__content">
          @if (notification.title) {
            <span class="notification__title">
              {{ notification?.title }}
            </span>
          }
          @if (notification.text) {
            <p class="notification__text">
              {{ notification.text }}
            </p>
          }
        </div>
        <i class="pi pi-times notification__close-icon" (click)="onHide()" aria-hidden="true"> </i>
      </div>
    </div>
  }`,
  styleUrl: './notification.component.scss',
  animations: [notificationAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, ButtonModule, NgOptimizedImage],
})
export class NotificationComponent {
  private readonly _notificationService: NotificationService = inject(NotificationService);

  public notification$ = this._notificationService.getNotification();

  public onHide(): void {
    this._notificationService.hideNotification();
  }
}
